import api from "../../http";
import { toApiError } from "../utils";
import type { Manufacturer } from "@practium/features/products";

export type ImportManufacturerParams = {
    file: File;
};

export type ImportedManufacturer = Omit<Manufacturer, "userId"> & {
    user: string;
    createdAt?: string;
    updatedAt?: string;
    __v?: number;
};

export type ManufacturerImportResponse = {
    created: number;
    updated: number;
    totalRows: number;
    errors: {
        row: number;
        message: string;
    }[];
    manufacturers: ImportedManufacturer[];
};

export async function importManufacturerFile({
    file
}: ImportManufacturerParams): Promise<ManufacturerImportResponse> {
    const formData = new FormData();

    formData.append("file", file);

    try {
        const response = await api.post("/manufacturer/import", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        });

        return response.data;
    } catch (error) {
        throw toApiError(error, "Erro ao importar fabricantes");
    }
}
